module.exports = __webpack_public_path__ + "img/success_d.34528243.gif";